var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarChassis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h3a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4h3a1 1 0 0 1 0 2h-3v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2h-3a1 1 0 0 1 0-2h3v-6h-3a1 1 0 0 1 0-2zm-31-2H6a2 2 0 0 0-2 2h3a1 1 0 0 1 0 2H4v6h3a1 1 0 0 1 0 2H4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4H9a1 1 0 0 1 0-2h3v-4a2 2 0 0 0-2-2zM41 3h3a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4h3a1 1 0 0 1 0 2h-3v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2h-3a1 1 0 0 1 0-2h3V5h-3a1 1 0 0 1 0-2zM10 1H6a2 2 0 0 0-2 2h3a1 1 0 0 1 0 2H4v6h3a1 1 0 0 1 0 2H4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V9H9a1 1 0 0 1 0-2h3V3a2 2 0 0 0-2-2zM30 4H18v2h-4v4h4v2h3v4h1v5h-1v12h1v4h-3v1h-5v4h5v1h10v-1h5v-4h-5v-1h-3v-4h1V21h-1v-5h1v-4h3v-2h4V6h-4V4z",
    "data-name": "Car Chasis"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarChassis);
export default __webpack_public_path__ + "static/media/car-chassis.ef7f1b9d3593dc7919ed059fc89a9e26.svg";
export { ForwardRef as ReactComponent };